import React, { useState } from 'react';
import { FaCheck, FaCopy } from 'react-icons/fa';
import Button from './Button';

const CopyButton = ({ value, label = 'Copiar resultado', disabled = false }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1600);
    } catch (error) {
      setCopied(false);
    }
  };

  return (
    <Button variant="ghost" onClick={handleCopy} disabled={disabled || !value} className="copy-button">
      {copied ? <FaCheck aria-hidden="true" /> : <FaCopy aria-hidden="true" />}
      <span>{copied ? 'Copiado' : label}</span>
    </Button>
  );
};

export default CopyButton;
